import { render } from "./AltaCliente.vue?vue&type=template&id=1aea4685"
import script from "./AltaCliente.vue?vue&type=script&lang=js"
export * from "./AltaCliente.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__